import { FastlinkRequest } from 'data/Payments/BankTransfer/types'
import React, { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

import { Wrapper as GeneralWrapper } from '../../styles'
import SplashScreen from './SplashScreen'

const YODLEE_SCRIPT_SRC = 'https://cdn.yodlee.com/fastlink/v4/initialize.js'

const Wrapper = styled(GeneralWrapper)<{ small: boolean }>`
  ${(p) =>
    p.small &&
    css`
      padding: 0;
    `}
`

type Props = {
  data: FastlinkRequest
  onBack: () => void
  onContinue?: () => void
  onSuccess: (providerAccountId: string, accountId: string) => void
}

const YodleeSDK = ({ data, onBack, onContinue, onSuccess }: Props) => {
  const [booted, setBooted] = useState<boolean>(false)

  useEffect(() => {
    // already added, don't add again
    if (window.fastlink) {
      return () => {
        window.fastlink.close()
      }
    }

    const script = document.createElement('script')
    script.src = YODLEE_SCRIPT_SRC
    script.async = true
    document.body.appendChild(script)
    return () => {
      window.fastlink.close()
    }
  }, [])

  const boot = () => {
    if (onContinue !== undefined) {
      onContinue()
    }

    window.fastlink.open(
      {
        accessToken: `Bearer ${data.token}`,
        fastLinkURL: data.fastlinkUrl,
        forceIframe: true,
        onClose: (data) => {
          if (!data.sites || !data.sites.length) {
            // no sites data, user abandoned flow
            onBack()
            return
          }
          // got site data, got a bank account
          const siteData = data.sites[0]
          onSuccess(siteData.providerAccountId, siteData.accountId)
        },
        params: data.fastlinkParams
      },
      'container-fastlink'
    )
    setBooted(true)
  }

  return (
    <Wrapper small={booted}>
      {!booted && <SplashScreen onBack={onBack} onClick={boot} />}
      <div id='container-fastlink' />
    </Wrapper>
  )
}

export default YodleeSDK
